RivalIQ.module('export.models.factories', function (factories, App, Backbone, Marionette, $, _) {

    'use strict';

    factories.ppt = function (model) {

        const config = model.config;

        let props = config.getProps();
        props = _.pick(props, 'landscapeId', 'companySetDescriptor', 'timePeriod', 'activeSources', 'focusCompanyId');

        // #11157 Make sure that "getSlides" is called after "getExportStyles" or
        // all your slides will all have the wrong branding image url.
        // Why? Because:
        // `curation.getExportStyles` calls
        // `RivalIQ.utils.branding.overrideReportStyles` which calls
        // `RivalIQ.apps.Reports.models.Slide.customizeBrandImages` which overrides
        // `getLarge` and `getSmall` of Slide.brandImages
        const styles = config.getExportStyles();
        const attrs = _.extend({
            styles: styles,
            branding: RivalIQ.state.view.getActiveBranding().toJSON(),
            activeBranding: RivalIQ.utils.branding.getActiveBrandingType(),
            slides: config.getSlides()
        }, props);

        model.set(attrs, {
            silent: true
        });
    };
});
